import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61407950"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card account-details",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "details-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1))
const _hoisted_4 = { class: "details-body" }
const _hoisted_5 = { class: "drow" }
const _hoisted_6 = { class: "k" }
const _hoisted_7 = { class: "v" }
const _hoisted_8 = { class: "drow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope" }),
  /*#__PURE__*/_createTextVNode(" E-mail")
], -1))
const _hoisted_10 = { class: "v" }
const _hoisted_11 = { class: "drow" }
const _hoisted_12 = { class: "k" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt" }, null, -1))
const _hoisted_14 = { class: "v" }
const _hoisted_15 = { class: "drow" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "Username / Nick", -1))
const _hoisted_17 = { class: "v" }
const _hoisted_18 = { class: "drow" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "Bio", -1))
const _hoisted_20 = { class: "v" }
const _hoisted_21 = {
  key: 0,
  class: "drow"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-github" }),
  /*#__PURE__*/_createTextVNode(" Github")
], -1))
const _hoisted_23 = { class: "v" }
const _hoisted_24 = {
  key: 1,
  class: "drow"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-linkedin" }),
  /*#__PURE__*/_createTextVNode(" Linkedin")
], -1))
const _hoisted_26 = { class: "v" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountBase = _resolveComponent("AccountBase")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AccountBase),
    (_ctx.user.avatar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.profile_details`)), 1),
            _createVNode(_component_router_link, {
              to: "/profile/settings",
              class: "btn-edit"
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.profile_edit`)), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.full_name`)), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.user.name), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.user.email), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.country`)), 1)
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.user.country), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.user.nick), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.user.bio), 1)
            ]),
            (_ctx.user.github_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, "@" + _toDisplayString(_ctx.user.github_url), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.linkedin_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.user.linkedin_url), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}